import { render, staticRenderFns } from "./Invoices.vue?vue&type=template&id=c80bf060&scoped=true&"
import script from "./Invoices.vue?vue&type=script&lang=js&"
export * from "./Invoices.vue?vue&type=script&lang=js&"
import style0 from "./Invoices.vue?vue&type=style&index=0&id=c80bf060&prod&lang=css&"
import style1 from "./Invoices.vue?vue&type=style&index=1&id=c80bf060&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80bf060",
  null
  
)

export default component.exports